import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SearchBarComponent, SearchBarSearchEvent } from '@core/ui';
import { PlatformcatalogSearchQueryField } from '@mp/content-manager/plattformkataloge/data-access';

interface SearchParams {
  searchTerm: string;
  field: PlatformcatalogSearchQueryField;
}

@Component({
  selector: 'mp-platformcatalogs-search-bar',
  templateUrl: './platformcatalogs-search-bar.component.html',
  styleUrl: './platformcatalogs-search-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchBarComponent],
})
export class PlatformCatalogsSearchBarComponent {
  @Input() searchTerm = '';

  @Input() field: PlatformcatalogSearchQueryField = PlatformcatalogSearchQueryField.All;

  @Output() readonly searched: EventEmitter<SearchParams> = new EventEmitter<SearchParams>();

  readonly fieldOptions = [
    {
      key: PlatformcatalogSearchQueryField.All,
      label: 'Alle Felder',
    },
    {
      key: PlatformcatalogSearchQueryField.PlatformCatalogName,
      label: 'Plattformkatalog',
    },
    {
      key: PlatformcatalogSearchQueryField.IndustryCatalogName,
      label: 'Industriekatalog',
    },
    {
      key: PlatformcatalogSearchQueryField.SupplierName,
      label: 'Lieferant',
    },
    {
      key: PlatformcatalogSearchQueryField.OrganizationName,
      label: 'Organisation',
    },
  ];

  onManualSearch({ searchTerm, field }: SearchBarSearchEvent): void {
    this.searched.emit({ searchTerm, field: field as PlatformcatalogSearchQueryField });
  }
}
